import { useEffect } from 'react'

/** Base app name shown in the browser tab, kept in sync with index.html. */
const BASE_TITLE = 'Snoots'

/**
 * Sets the browser tab title for the current page, suffixed with the app name
 * (e.g. "Sign in · Snoots"). Pass `undefined` while data is still loading to
 * leave the title untouched. `null` explicitly falls back to the base name.
 * Restores the base title on unmount.
 */
export function useDocumentTitle(title?: string | null) {
  useEffect(() => {
    if (title === undefined) return
    document.title = title ? `${title} · ${BASE_TITLE}` : BASE_TITLE
    return () => {
      document.title = BASE_TITLE
    }
  }, [title])
}
